import { render, staticRenderFns } from "./ModalResend.vue?vue&type=template&id=4154b908&scoped=true&"
import script from "./ModalResend.vue?vue&type=script&lang=js&"
export * from "./ModalResend.vue?vue&type=script&lang=js&"
import style0 from "./ModalResend.vue?vue&type=style&index=0&id=4154b908&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4154b908",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4154b908')) {
      api.createRecord('4154b908', component.options)
    } else {
      api.reload('4154b908', component.options)
    }
    module.hot.accept("./ModalResend.vue?vue&type=template&id=4154b908&scoped=true&", function () {
      api.rerender('4154b908', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/trays/managementTray/modals/ModalResend.vue"
export default component.exports